


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyCirBVtF45H3UPpTzcdNQO_fVt_ZA0_Q2g",
  authDomain: "vision-first-24263.firebaseapp.com",
  projectId: "vision-first-24263",
  storageBucket: "vision-first-24263.firebasestorage.app",
  messagingSenderId: "474202375322",
  appId: "1:474202375322:web:a384a0eb5ebaf7246a4b23"
};



const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export